import client from '@/shared/apis/client'
import {
  CheckpointsResponse,
  CheckpointUpdateResponse,
  CheckpointBulkUpdateResponse,
} from '@/apps/legacy/features/guidance/types/guidanceCheckPoints'

export interface UpdateCheckpointSelectionRequest {
  isSelected: boolean
}

export interface UpdateMultipleSelectionsRequest {
  selections: Array<{
    id: string
    isSelected: boolean
  }>
}

export const getCheckpoints = (requestId: string) => {
  return client.get<CheckpointsResponse>(
    `/api/yakureki/${requestId}/checkpoints/`
  )
}

export const updateCheckpointSelection = (
  requestId: string,
  checkpointId: string,
  isSelected: boolean
) => {
  return client.put<CheckpointUpdateResponse>(
    `/api/yakureki/${requestId}/checkpoints/${checkpointId}/selection/`,
    {
      isSelected,
    }
  )
}

export const updateMultipleSelections = (
  requestId: string,
  selections: Array<{ id: string; isSelected: boolean }>
) => {
  return client.put<CheckpointBulkUpdateResponse>(
    `/api/yakureki/${requestId}/checkpoints/selections/`,
    { selections }
  )
}
